import { withMissingTranslationFallback } from 'shared/utils/withMissingTranslationFallback';

const MR = 'MR';
const MS = 'MS';
const DR = 'DR';
const PROFESSOR = 'PROFESSOR';

export const userTitles = [
  MR,
  MS,
  DR,
  PROFESSOR,
];

export const userTitlesMessagesRaw = {
  MR: { id: 'General.title.Mr', defaultMessage: '** Mr.' },
  MS: { id: 'General.title.Ms', defaultMessage: '** Ms.' },
  DR: { id: 'General.title.Dr', defaultMessage: '** Dr.' },
  PROFESSOR: { id: 'General.title.Prof', defaultMessage: '** Prof.' },
};

export const userTitlesMessages = withMissingTranslationFallback(userTitlesMessagesRaw);
